function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { StyleSheet } from 'react-native';
import * as PIXI from 'pixi.js';
import * as R from 'unitx/ramda';
import { PixiComponent } from '@inlet/react-pixi';
import { wrapComponent } from 'unitx-ui';
import * as C from 'unitx/color';
import { applyDefaultProps } from "../../utils";
// dropShadow
// dropShadowAlpha
// dropShadowAngle
// dropShadowBlur
// dropShadowColor
// dropShadowDistance
const PositionStyleKeys = ['left', 'top', 'width', 'height'];

const processTextProps = props => {
  const {
    style: defaultStyle = {},
    color
  } = props;
  const style = StyleSheet.flatten(defaultStyle);
  return _objectSpread(_objectSpread({}, props), {}, {
    style: R.pick(PositionStyleKeys)(style),
    textStyle: R.pipe(R.toPairs, R.map(([key, value]) => R.cond([[R.equals('color'), () => ['fill', C.rgbNumber(value)]], [R.equals('textShadowColor'), () => ['dropShadowColor', C.rgbNumber(value)]], [R.equals('textShadowRadius'), () => ['dropShadowBlur', C.rgbNumber(value)]], [R.equals('textShadowOffset'), () => {
      var _R$values;

      return ['dropShadowDistance', (_R$values = R.values(value)) === null || _R$values === void 0 ? void 0 : _R$values[0]];
    }], [R.T, R.always([key, value])]])(key)), R.fromPairs, R.cond([[R.anyPass([R.has('dropShadowColor'), R.has('dropShadowBlur'), R.has('dropShadowDistance')]), R.set(R.lensProp('dropShadow'), true)], [R.T, R.identity]]))(R.omit([PositionStyleKeys])(_objectSpread(_objectSpread({}, style), {}, {
      color
    })))
  });
};

const TextPIXI = PixiComponent('PIXIText', {
  create: props => {
    const {
      text = '',
      textStyle = {},
      isSprite
    } = processTextProps(props);
    const mutableInstance = new PIXI.Text(text, textStyle);
    return R.ifElse(R.isTrue, () => {
      mutableInstance.updateText(false);
      return new PIXI.Sprite(mutableInstance.texture);
    }, R.always(mutableInstance))(isSprite);
  },
  applyProps: (mutableInstance, oldProps, props) => {
    const _processTextProps = processTextProps(oldProps),
          {
      text: _,
      textStyle: __
    } = _processTextProps,
          oldPropsRest = _objectWithoutProperties(_processTextProps, ["text", "textStyle"]);

    const _processTextProps2 = processTextProps(props),
          {
      text = '',
      textStyle = {},
      isSprite
    } = _processTextProps2,
          propsRest = _objectWithoutProperties(_processTextProps2, ["text", "textStyle", "isSprite"]);
    /* eslint-disable functional/immutable-data, functional/no-expression-statement */


    applyDefaultProps(mutableInstance, oldPropsRest, propsRest);
    R.unless(R.isTrue, () => {
      mutableInstance.text = text;
      mutableInstance.style = textStyle;
    })(isSprite);
    /* eslint-enable functional/immutable-data, functional/no-expression-statement */
  }
});

const Text = props => {
  const {
    children
  } = props,
        rest = _objectWithoutProperties(props, ["children"]);

  return /*#__PURE__*/React.createElement(TextPIXI, _extends({
    text: children
  }, rest));
};
/**
 * ## Usage
 * To use Text on Graph
 * Check example
 *
 * ```js live=true
 * <Graph
 *  style={{ width: '100%', height: 250 }}
 *  nodes={[
 *    {
 *      id: 1,
 *      position: { x: 10, y: 10 },
 *      data: { city: 'Amsterdam' }
 *    },
 *    {
 *      id: 2,
 *      position: { x: 300, y: 10 },
 *      data: { city: 'Maastricht' }
 *    },
 *  ]}
 *  edges={[
 *    { id: 51, source: 1, target: 2 }
 *  ]}
 *  renderNode={({ item: { data } }) => (
 *    <Graph.View
 *      style={{ width: 100, height: 100,}}
 *    >
 *      <Graph.Text
 *         style={{ fontSize: 20 }}
 *       >
 *        {data.city}
 *       </Graph.Text>
 *    </Graph.View>
 * )}
 * />
 * ```
 */


export default wrapComponent(Text, {
  withTheme: true
});